import axios from "axios";
import {apiUrl} from "../../Config/const";
const axiosConexionConfig = () => {
    const defaultOptions = {
        baseURL: apiUrl,
        headers: {
            'Access-Control-Max-Age': '600',
            'Content-Type': 'application/json',
        }
    };
    
    // Create instance
    let instance = axios.create(defaultOptions);
    instance.CancelToken=axios.CancelToken
     //Create an interceptor for each request
     instance.interceptors.request.use(function (config) {
        const token = localStorage.getItem('adal.idtoken');
        if(token===undefined||token===""||token===null){
            return window.location.href = '/logout';
        }else{
            config.headers.Authorization = 'Bearer ' + token;
        }
        return config;
    });

    return instance;
};
export default (axiosConexionConfig());
